import styled, { css } from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { media } from 'src/styles/designs';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { useTranslate } from 'react-t7e';
import { EventPageHeading } from 'src/modules/events/components/EventPage/EventPageHeading';
import { EventAgendaScheduleDay } from 'src/modules/events/models';
import { casePathEmptyString } from 'src/utils/casePathEmptyString';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { Events } from 'src/graphql/schema.graphql';
import { Button } from 'src/components/common/Button';
import { ScrollToSectionOnClick } from 'src/components/common/ScrollToSectionOnClick';

export interface EventPageAgendaHeaderProps {
  schedule: EventAgendaScheduleDay[];
  agenda: Pick<Events, 'translations' | 'subEvents'>;
}

const Description = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  color: ${({ theme }) => theme.text.palette.primary};
  text-transform: none;
  letter-spacing: 0;
  margin-bottom: 40px;

  ${media.w.lessThan.desktop} {
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 26px;
  }
`;

const ContentContainer = styled(ConstraintContainer)`
  max-width: 855px;
  padding: 0 !important;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 25px;
  width: 100%;
`;

const NavButton = styled(Button)<{ $active?: boolean }>`
  ${casePathEmptyString('$active')(
    css`
      color: ${({ theme }) => theme.text.palette.accent} !important;
    `,
  )}
`;

export const EventPageAgendaHeader = ({
  schedule,
  agenda,
}: EventPageAgendaHeaderProps) => {
  const { _ } = useTranslate();
  const translatedAgenda = useTranslateItem(agenda);

  return (
    <>
      <EventPageHeading>{_('agenda')}</EventPageHeading>

      <ContentContainer>
        {translatedAgenda.agendaDescription && (
          <Description>
            <Markdown>{translatedAgenda.agendaDescription}</Markdown>
          </Description>
        )}

        <ButtonsContainer>
          {schedule.map((day) => (
            <ScrollToSectionOnClick key={day.label} id={day.id} offset={30}>
              <NavButton kind="text">{day.label}</NavButton>
            </ScrollToSectionOnClick>
          ))}
        </ButtonsContainer>
      </ContentContainer>
    </>
  );
};
